var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIconsCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud__Property 1=Cloud, State=Default",
    className: "cloud__Property cloud__1=Cloud, cloud__State=Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cloud__Vector (Stroke)",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.674 8.646A6.688 6.688 0 0 1 18.933 9.65a5.618 5.618 0 0 1-.8 11.176H6.902a6.151 6.151 0 0 1-1.227-12.18Zm1.668-.107a6.124 6.124 0 0 1 3.25 1.215.802.802 0 0 1-.963 1.283 4.523 4.523 0 0 0-3.165-.888 4.547 4.547 0 0 0 .437 9.072h11.233a4.012 4.012 0 0 0 .657-7.97 6.663 6.663 0 0 1-1.384 2.865.802.802 0 1 1-1.237-1.022 5.055 5.055 0 0 0 1.161-3.233 5.081 5.081 0 0 0-9.989-1.322Z",
    className: "cloud__Vector cloud__(Stroke)",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconsCloud);
export default __webpack_public_path__ + "static/media/sidebar-icons-cloud.ca5a68d26505131becfac63f66443cae.svg";
export { ForwardRef as ReactComponent };